import script from "./NotificationPermission.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationPermission.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationPermission.vue?vue&type=style&index=0&id=1fa86432&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fa86432"]])

export default __exports__